import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import styles from "./HomeBottomDesc.module.css";
import ListView from "../common/ListView";
import about01 from "../../img/main_about_01.jpg";
import about02 from "../../img/main_about_02.jpg";
import about03 from "../../img/main_about_03.jpg";
import icon01 from "../../img/main_icon_01.png";
import icon02 from "../../img/main_icon_02.png";
import icon03 from "../../img/main_icon_03.png";
import { MapCount } from "../common/Common";

interface MapCountProps {
    mapCount: (...args: any) => any;
}

export interface MainBottomDescProps {
    iconSrc: string;
    aboutSrc: string;
    onclick?: () => void | undefined;
    tit: string;
    des: string;
}

/**
 * @author sukim91
 * @date 2022-09-27 10:26:55
 * @remark 메인 컴포넌트
 * @param props MapCountProps
 * @props 1) MapCountProps
 *      mapCount(required) : 지도 카운트 결과값
 *        2) MainBottomDescProps
 *      iconSrc(required) : 아이콘 이미지 경로
 *      aboutSrc(required) : 메인 이미지 경로
 *      onclick : 클릭 시 실행되는 함수
 *      tit(required) : 제목 내용
 *      des(required) : 설명 내용
 * @returns <div>
 */
export function HomeBottomDesc(props: MapCountProps) {
    const [mapCount, setMapCount] = useState<MapCount>();

    // 쿠키
    const [cookies] = useCookies(["KMLN", "KMNM"]);
    const [isMember, setIsMember] = useState(Number(cookies.KMLN) === 1);
    const [name, setName] = useState(cookies.KMNM);

    /**
     * 오늘의 지도/전체 지도 개수 표시,
     * 쿠키 로그인 여부 및 유저명 표시 함수
     */
    useEffect(() => {
        // 오늘의 지도/전체 지도 카운트
        const getMapCount = async () => {
            const result: MapCount = await props.mapCount();
            result && setMapCount(result);
        };

        getMapCount();
        // 쿠키 읽어오기
        setIsMember(Number(cookies.KMLN) === 1);
        setName(cookies.KMNM);
    }, [props, cookies]);

    const mainBottomDescItem = [
        {
            iconSrc: icon01,
            aboutSrc: about01,
            onclick: () => {},
            tit: "모두의지도 서비스",
            des:
                "<span>모두의지도</span>는 GeoReference 데이터를 이용하여 위치정보 데이터를 " +
                "공간정보 데이터로 변환하여 텍스트 데이터를 시각적으로 표현합니다.<br /><br /> " +
                "공간정보를 표현하기 위해 다양한 아이콘을 이용하여 지도위에 마커를 " +
                "표현하고 마커의 속성데이터를 확인할 수 있는 기능을 지원하며 속성데" +
                "이터를 검색할 수 있는 기능을 지원합니다.",
        },
        {
            iconSrc: icon02,
            aboutSrc: about02,
            onclick: () => {},
            tit: "정확한 지도 제작 지원",
            des:
                "<span>모두의지도</span>는 지도당 최대 20,000건의 데이터 변환이 가능하며 제작된 " +
                "지도에 개별적인 편집을 통해 마커를 추가하거나 마커 삭제를 지원합니다.",
        },
        {
            iconSrc: icon03,
            aboutSrc: about03,
            onclick: () => {},
            tit: "다양한 분석 기법 도입",
            des:
                "<span>모두의지도</span>는 시각적인 데이터 분석을 위하여 직관적 데이터 표현방법인 " +
                "히트맵, 버블맵 분석 등을 지원합니다.<br /><br /> " +
                "모두의지도는 길찾기 엔진을 활용한 최적의 길찾기 서비스를 제공하며 " +
                "도로 네트워크 기반의 영역을 검출한 반경검색을 제공합니다.<br /><br /> " +
                "모두의지도로 제작되어 생성된 지도 데이터를 다양한 종류의 " +
                "파일 형식으로 내보내기 기능을 지원합니다.",
        },
    ];

    const renderItem = (props: MainBottomDescProps, index: number) => {
        return (
            <div className={styles.desc_container} key={`bottom_desc_${index}`}>
                <div className={styles.desc_wrapper}>
                    <img src={props.iconSrc} className={styles.main_icon} />
                    <span className={styles.tit}>{props.tit}</span>
                    <span className={styles.desc} dangerouslySetInnerHTML={{ __html: props.des }}></span>
                </div>
                <img src={props.aboutSrc} className={styles.main_about} />
            </div>
        );
    };

    return (
        <div className={styles.background}>
            <div className={styles.middle_bar}>
                <div className={styles.contents_wrapper}>
                    <div className={styles.count_container}>
                        <div className={styles.count_title_container}>
                            <span className={styles.count_title_main}>TODAY</span>
                            <span className={styles.count_title_sub}>오늘의 지도</span>
                        </div>
                        <span className={styles.count_num}>{mapCount ? mapCount.today : 0}</span>
                    </div>
                    <div className={styles.divider}></div>
                    <div className={styles.count_container}>
                        <div className={styles.count_title_container}>
                            <span className={styles.count_title_main}>TOTAL</span>
                            <span className={styles.count_title_sub}>전체 지도</span>
                        </div>
                        <span className={styles.count_num}>{mapCount ? mapCount.total : 0}</span>
                    </div>
                </div>
            </div>
            <div className={styles.bottom_container}>
                <ListView data={mainBottomDescItem} renderItem={renderItem} />
            </div>
        </div>
    );
}

export default HomeBottomDesc;
